module.exports = __webpack_public_path__ + "img/hotel-med.d0dc7d83.png";